import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { CompanyService } from 'src/app/setting/services/company.service';
import { EmployeeDatetimeType } from '../../../models/EmployeeDatetimeType';
import { DatetimesTypesStoreService } from '../../../services/datetimes-types-store.service';

@Component({
    selector: 'app-meal-vouchers-setting',
    templateUrl: './meal-vouchers-setting.component.html',
    styleUrls: ['./meal-vouchers-setting.component.css']
})
export class MealVouchersSettingComponent implements OnInit {
    @Input() public settings: any;

    public form: UntypedFormGroup;
    public datetimeTypes$: Observable<EmployeeDatetimeType[]>;

    public constructor(
        private _companyService: CompanyService,
        private _fb: UntypedFormBuilder,
        private _datetimeTypesStore: DatetimesTypesStoreService,
    ) { }

    public get f(): { [formControlName: string]: AbstractControl; } {
        return this.form.controls;
    }

    public ngOnInit(): void {
        this.datetimeTypes$ = this._datetimeTypesStore.datetimeTypes$;

        this.form = this._fb.group({
            'company.attendance.meal_vouchers_active': [false],
            'company.attendance.meal_vouchers_hours': [0],
            'company.attendance.meal_vouchers_datetime_types': [null],
            'company.attendance.meal_allowance_active': [false],
            'company.attendance.meal_allowance_hours': [0],
            'company.attendance.meal_allowance_datetime_types': [null],
        });

        this.form.patchValue({
            'company.attendance.meal_vouchers_active': this.settings.company_settings.attendance?.meal_vouchers_active || false,
            'company.attendance.meal_vouchers_hours': this.settings.company_settings.attendance?.meal_vouchers_hours || 0,
            'company.attendance.meal_vouchers_datetime_types': this.settings.company_settings.attendance?.meal_vouchers_datetime_types || null,
            'company.attendance.meal_allowance_active': this.settings.company_settings.attendance?.meal_allowance_active || false,
            'company.attendance.meal_allowance_hours': this.settings.company_settings.attendance?.meal_allowance_hours || 0,
            'company.attendance.meal_allowance_datetime_types': this.settings.company_settings.attendance?.meal_allowance_datetime_types || null,
        });
    }

    public onSubmit(): void {
        const value = this.form.value;

        value.settings_type = 'attendance';

        void this._companyService.saveCompanySetting(this.form.value);
    }
}
